<script>
import moment from 'moment'
import {
  formatPriceWithSign
} from '@/utils/helpers'

import starIcon from '@/assets/images/icons/star.svg?inline'
import infoIcon from '@/assets/images/icons/info.svg?inline'
import locationIcon from '@/assets/images/icons/location.svg?inline'

export default {
  name: 'FavoritesTable',
  components: {
    starIcon,
    infoIcon,
    locationIcon,
  },
  props: {
    collection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isDeleteMode() {
      return this.$store.getters['favorites/isDeleteMode']
    },
    currentCollection() {
      return this.$store.getters['favorites/getCollection']
    },
    selected() {
      return this.currentCollection.filter(item => item.isSelected)
    }
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    formatPrice(price, slug) {
      const dictionary = this.$store.getters.getDictionary('favorites.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
    select(list) {
      const selectedList = list.map(item => item.favoriteId)

      this.currentCollection.forEach(({ favoriteId, isSelected }) => {
        this.$store.commit('favorites/updateSelectState', {
          id: favoriteId,
          currentState: !selectedList.includes(favoriteId)
        })
      })
    }
  }
}
</script>

<template>
  <b-table
    :data="collection"
    :checkable="isDeleteMode"
    checkbox-position="left"
    :checked-rows="selected"
    :row-class="(row, index) => 'search-table__item'"
    class="search-table__list"
    @check="select($event)"
  >
    <template slot-scope="item">
      <b-table-column
        label="Отель"
      >
        <div class="search-table__item-data">
          <div class="search-table__item-rating">
            <div class="search-table__item-stars">
              <starIcon
                v-for="i in item.row.category"
                :key="`star_${i}`"
              />
            </div>
            <div
              v-if="item.row.rating"
              class="search-table__item-rating-count"
            >
              {{ item.row.rating }}/100
            </div>
          </div>
          <h2 class="search-table__item-title">
            {{ item.row.hotelName }}
          </h2>
          <a
            :href="`http://www.google.com/maps/place/${item.row.latitude},${item.row.longitude}`"
            target="_blank"
            class="search-table__item-location"
          >
            <location-icon />
            <span>{{ item.row.city }}</span>
          </a>
        </div>
      </b-table-column>
      <b-table-column
        label="Дата заезда"
        centered
      >
        <div class="search-table__item-date">
          <p>{{ formatDate(item.row.startDate) }}</p>
        </div>
      </b-table-column>
      <b-table-column
        label="Ночей"
        centered
      >
        <div class="search-table__item-text">
          <p>{{ item.row.accommodationDuration }}</p>
        </div>
      </b-table-column>
      <b-table-column
        label="Питание"
        centered
      >
        <div class="search-table__item-text">
          <p>{{ item.row.mealType }}</p>
        </div>
      </b-table-column>
      <b-table-column
        label="Номер"
        centered
      >
        <div class="search-table__item-text">
          <p>{{ item.row.roomType }}</p>
        </div>
      </b-table-column>
      <b-table-column
        label="Размещение"
        centered
      >
        <div class="search-table__item-text">
          <p>{{ item.row.tourists }}</p>
        </div>
      </b-table-column>
      <b-table-column
        label=" "
        centered
      >
        <div class="search-table__item-info">
          <b-dropdown aria-role="list">
            <infoIcon
              slot="trigger"
              fill="#55b7a1"
            />
            <div
              v-for="(fact, index) in item.row.facts.main"
              :key="`${fact.slug}_${index}`"
              class="search-table__item-info-item"
            >
              <img
                class="search-table__item-info-item-image"
                :src="fact.iconUrl"
              >
              <p>{{ fact.name }} {{ fact.value }}</p>
            </div>
          </b-dropdown>
        </div>
      </b-table-column>
      <b-table-column
        label="Стоимость"
        centered
      >
        <router-link
          :to="{
            name: 'Cart',
            params: {
              id: item.row.id,
              service: 'hotels'
            },
            query: {
              ...item.row.cartParams,
              checkInDate: formatDate(item.row.cartParams.checkInDate)
            }
          }"
          class="search-table__item-link"
        >
          <span>
            от {{ formatPrice(item.row.price.amount, item.row.price.currency) }}
          </span>
        </router-link>
      </b-table-column>
    </template>
  </b-table>
</template>
